<template>
  <div :class="isMobile? 'search-mobile' : 'search-wrap'" id="search-results">
    <a-input
          style="width: 80%;display:inline-block"
          id="searchBox"
      :class="isMobile? 'mobile' : null"
      v-model="search"
      :placeholder="$t('nav.search')"
      @input="handleSearch"
        >
        </a-input>
        <a style="display:inline-block;color:white;padding-left:10px" v-if="!isMobile" @click="$emit('closeSearch')">{{ $t("nav.close") }}<a-icon type="close" style="margin-left:10px;vertical-align:-0.2em"/></a>
    <!-- <input
      type="text"
      class="search"
      :class="isMobile ? 'mobile' : null"
      v-model="search"
      :placeholder="$t('nav.search')"
      @input="handleSearch"
      v-if="mobileSearchBar"
    />
    <img :src="$images.search" alt="search" v-on="{ click: isMobile? toggleSearchBar : searchSite}" /> -->
    <div class="search-result" :class="isMobile? 'mobile' : null" v-if="showResults">
      <div class="search-result-header">
        <strong>{{ $t("search.suggestions") }}</strong><a-icon type="close" style="right: 30px;position: absolute;" @click="({ showResults: !showResults })" />
      </div>
      <div class="search-item" v-for="user in usersResult" :key="user.usr_id">
        <router-link :to="getUserLink(user)">
          <strong>{{ $t("search.user") }}</strong>
          <span>{{ user.usr_firstname + " " + user.usr_lastname }}</span>
        </router-link>
      </div>
      <div
        class="search-item"
        v-for="item in agendaResult"
        :key="'agenda-' + item.agn_id"
      >
        <router-link to="/agenda">
          <strong>{{ $t("search.agenda") }}</strong>
          <span>{{ item.agn_name }}</span>
        </router-link>
      </div>
      <div
        class="search-item"
        v-for="item in boothsResult"
        :key="'booth-' + item.loc_id"
      >
        <router-link :to="handleType(item)">
          <strong>{{ $t("search." + item.type) }}</strong>
          <span>{{ handleItemText(item) }}</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  props: {
    mobileSearchBar: {
      type: Boolean,
      default: true,
    },
    isMobile: {
      type: Boolean,
    },
  },
  data() {
    return {
      search: "",
      usersResult: [],
      agendaResult: [],
      boothsResult: [],
      searchTimeoutId: null,
      showResults: false,
    };
  },
  mounted() {
    this.EventBus.$on("handle-search", this.handleSearchResult);
  },
  methods: {
    handleSearch() {
      if (this.searchTimeoutId) {
        clearTimeout(this.searchTimeoutId);
      }
      this.searchTimeoutId = setTimeout(this.searchSite, 500);
    },
    async searchSite() {
      if (!this.search) {
        this.showResults = false;
        return;
      }
      try {
        let res = await api.search(this.search);
        let check = false;
        if (res.data.users) {
          this.usersResult = res.data.users;
          check = true;
        }
        if (res.data.agenda) {
          this.agendaResult = res.data.agenda;
          check = true;
        }
        if (res.data.booths) {
          this.boothsResult = res.data.booths;
          check = true;
        }
        if (check) {
          this.showResults = check;
        }
      } catch (error) {
        console.log(error);
      }
    },
    getUserLink(item) {
      return `/profile/${item.usr_firstname.toLowerCase()}-${item.usr_lastname.toLowerCase()}-${
        item.usr_id
      }`;
    },
    handleSearchResult(e) {
      if (e.target.id !== "search-result") {
        this.search = "";
        this.showResults = false;
      }
      if (e.target.id !== "show-profile") {
        this.showProfile = false;
      }
    },
    toggleSearchBar() {
      this.$emit("toggle-search-bar");
    },
    handleType(item) {
      if (item.type === "info") {
        return "/info-booth";
      }
      if (item.type === "booth") {
        return `/booth/${item.loc_name}`;
      }
      if (item.type === "conf") {
        return `/live/1`;
      }
    },
    handleItemText(item) {
      if (item.type === "info") {
        return this.$t("search.info");
      }
      if (item.type === "booth") {
        return item.loc_fullname;
      }
      if (item.type === "conf") {
        return this.$t("search.conf");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search {
  box-sizing: border-box;
  display: inline-block;
  background: var(--main-color-shade);
  height: 32px;
  min-width: 230px;
  padding: 0 14px;
  border-radius: 36px;
  border: none;
  outline: none;
  font-family: "Roboto", sans-serif;
  font-size: 1.05rem;
  width: auto;
  &.mobile {
    min-width: unset;
    flex-grow: 1;
  }
}
.search-wrap {
  margin-right: 23px;
  position: relative;
  img {
    position: relative;
    left: -25px;
    height: 13px;
    cursor: pointer;
  }
}
.search-result-header {
  height: 42px;
  background: #efefef;
  display: flex;
  align-items: center;
  padding-left: 7px;
  box-sizing: border-box;
}
.search-mobile {
  // height: 15px;
  margin-right: 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  img {
    margin-left: 5px;
    height: 100%;
    min-height: 15px;
  }
}
.search-mobile #searchBox{
  color: black !important;
  width: 100% !important;
  padding: 0;
}
.search-result {
  position: absolute;
  top: 100%;
  margin-top: 10px;
  border-radius: 10px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.25);
  width: 100%;
  background: #fff;
  max-height: calc(min(30vh, 300px));
  overflow: auto;
  &.mobile {
    left: 0;
    right: 0;
    top: 100%;
    width: auto;
  }
}
.search-result.mobile{
  top:17% !important;
  color: black !important;
  z-index: 9;
}
.search-item {
  padding: 10px;
  border-bottom: 1.5px #c4c4c4 solid;
}
.search:focus,
.search-wrap:focus {
  outline: none;
}
.search::placeholder {
  color: var(--secondary-color);
}
</style>